import type { GroupClassCardItem } from "@/ui/components/groupClasses/series/GroupClassCard";
import GroupClassCard from "@/ui/components/groupClasses/series/GroupClassCard";
import GroupClassSeriesCard from "@/ui/components/groupClasses/series/GroupClassSeriesCard";

interface GroupClassSeriesListItemProps {
  forWhom?: string;
  isAppUserSupport: boolean;
  isListLoading: boolean;
  item: GroupClassCardItem | GroupClassSeries;
  onSelect: (args: {
    externalId: string;
    groupSectionId?: string;
    title: string;
  }) => void;
  patientId: string;
}

// renders one row of the group list: the v2 GroupClassCard when the item is a normalized
// card view-model (has `id`), else the v1 GroupClassSeriesCard.
const GroupClassSeriesListItem = ({
  forWhom,
  isAppUserSupport,
  isListLoading,
  item,
  onSelect,
  patientId,
}: GroupClassSeriesListItemProps) => {
  if ("id" in item) {
    return (
      <GroupClassCard
        description={item.description}
        groupClassExternalId={item.id}
        iconName={item.iconName}
        isCore={item.isCore}
        isRegistered={item.isRegistered}
        nextDateString={item.nextDateString}
        numberOfOptions={item.numberOfOptions}
        onSelect={(externalId) =>
          onSelect({
            externalId,
            groupSectionId: item.groupSectionId,
            title: item.title,
          })
        }
        recurrenceString={item.recurrenceString}
        title={item.title}
      />
    );
  }

  return (
    <GroupClassSeriesCard
      attendeeTypes={item.attendeeTypes}
      description={item.description}
      forWhom={forWhom}
      groupClassExternalId={item.groupClassExternalId}
      iconName={item.iconName}
      isAppUserSupport={isAppUserSupport}
      isLoading={isListLoading}
      isSensitive={item.isSensitive}
      isUserRegistered={item.isUserRegistered}
      onSelect={(externalId) => onSelect({ externalId, title: item.title })}
      patientExternalId={patientId}
      recurrenceDisplayString={item.recurrenceDisplayString}
      title={item.title}
    />
  );
};

export default GroupClassSeriesListItem;
